export class NovaPessoa{
  nome: string;
  telefone: string;
  documento: string;
  tipoDocumento: number;
}
